/**
  * 省市区 接口的统一出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const area = {
    // 列表
    list(params) {
        return axios.get(api + 'intangibleCommon/area', { params: params })
    },
    // 下拉列表
    droplist(params) {
        return axios.get(api + 'intangibleCommon/areadroplist', { params: params })
    },
    // 添加
    create(params) {
        return axios.post(api + 'intangibleCommon/areacreate', qs.stringify(params))
    },
    // 修改
    edit(params) {
        return axios.post(api + 'intangibleCommon/areaedit', qs.stringify(params))
    },
    // 详情
    detail(params) {
        return axios.post(api + 'intangibleCommon/areadetail', qs.stringify(params))
    },

}

// 导出接口
export default area
